define.alias("shared/components/shared/social/facebook-page", "settings/components/shared/social/facebook-page");